module.exports = ".mt30{\n    margin-right: 85px;\n}"